import {
  createSpinner,
  scrollToEvent,
  validateCheckbox,
  validateEmail,
  validateTextarea,
  validateTextInput,
} from "../../helpers.js";
import { project } from "../../initializeStats.js";
import { btnAnimation } from "../../btnAnimation.js";

export const validateAndSubmitForm = () => {
  document.querySelectorAll("textarea").forEach((ta) => {
    function adjustHeight() {
      ta.style.height = "54px";
      ta.style.height = `${ta.scrollHeight}px`;
    }
    ta.addEventListener("input", adjustHeight);
  });

  const forms = document.querySelectorAll(".contact-form");
  if (forms.length) {
    forms.forEach((form) => {
      const textInputs = form.querySelectorAll(
        '.form-field[name="name"], .form-field[name="company"]'
      );
      const textareas = form.querySelectorAll('.form-field[name="answer"]');
      const phoneNumbers = form.querySelectorAll('.form-field[name="phone"]');
      const mails = form.querySelectorAll('.form-field[name="email"]');
      const checkboxesRequired = form.querySelectorAll(
        ".form-checkbox--required input"
      );
      const checkboxesNotRequired = form.querySelectorAll(
        ".form-checkbox:not(.form-checkbox--required) input"
      );

      textInputs.forEach((el) => {
        el.addEventListener("input", function () {
          if (el.closest("fieldset").classList.contains("has-error")) {
            validateTextInput(this, 1);
          }
        });
        el.addEventListener("change", function () {
          validateTextInput(this, 1);
        });
        // el.addEventListener('keydown', (event) => {
        //   if (event. && event.key.match(/[0-9]/)) {
        //     event.preventDefault();
        //   }
        // });
      });

      textareas.forEach((el) => {
        el.addEventListener("input", function () {
          if (el.closest("fieldset").classList.contains("has-error")) {
            validateTextarea(this, 2);
          }
        });
        el.addEventListener("change", function () {
          validateTextarea(this, 2);
        });
      });

      phoneNumbers.forEach((el) => {
        // el.addEventListener('input', function () {
        //   if (el.closest('fieldset').classList.contains('has-error')) {
        //     validatePhoneNumber(this);
        //   }
        // });
        // el.addEventListener('change', function () {
        //   validatePhoneNumber(this);
        // });
        el.addEventListener("keydown", (event) => {
          const { key } = event;
          const isAllowedInput = key && key.match(/[0-9\+\-]/);
          const isBackspaceOrDelete =
            event.keyCode === 8 || event.keyCode === 46;
          if (!isAllowedInput && !isBackspaceOrDelete) {
            event.preventDefault();
          }
        });
      });

      mails.forEach((el) => {
        el.addEventListener("input", function () {
          if (el.closest("fieldset").classList.contains("has-error")) {
            validateEmail(this);
          }
        });
        el.addEventListener("change", function () {
          validateEmail(this);
        });
      });

      checkboxesRequired.forEach((el) => {
        el.addEventListener("change", function () {
          validateCheckbox(this);
        });
      });

      const submitBtn = form.querySelector(".btn-main");

      const data = {};

      // oddanie glosu - wysylanie danych z formularza
      submitBtn.addEventListener("click", (e) => {
        e.preventDefault();
        let formIsValid = true;

        // walidacja formularza

        textInputs.forEach((el) => {
          if (!validateTextInput(el, 1)) {
            formIsValid = false;
          } else {
            data[el.getAttribute("id")] = el.value;
          }
        });

        textareas.forEach((el) => {
          if (!validateTextarea(el, 1)) {
            formIsValid = false;
          } else {
            data[el.getAttribute("id")] = el.value;
          }
        });

        phoneNumbers.forEach((el) => {
          if (el.value.length > 0) {
            data[el.getAttribute("id")] = el.value;
          }
        });

        mails.forEach((el) => {
          if (!validateEmail(el)) {
            formIsValid = false;
          } else {
            data[el.getAttribute("id")] = el.value;
          }
        });

        checkboxesRequired.forEach((el) => {
          if (!validateCheckbox(el)) {
            formIsValid = false;
          } else {
            data[el.getAttribute("id")] = el
              .closest("fieldset")
              .querySelector("label").innerText;
          }
        });

        checkboxesNotRequired.forEach((el) => {
          if (el.checked) {
            data[el.getAttribute("id")] = el
              .closest("fieldset")
              .querySelector("label").innerText;
          }
        });

        if (formIsValid) {
          createSpinner(form, true);
          form.reset();

          /* WYSYŁANIE FORMULARZA */
          const url = form.getAttribute("data-url");
          (async () => {
            try {
              const response = await (
                await fetch(url, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(data),
                })
              ).text();

              const vC = form.closest(".form__wrapper");
              vC.innerHTML = response;
              if (vC.querySelectorAll(".form__response .btn-main")) {
                btnAnimation(vC.querySelectorAll(".form__response .btn-main"));
              }
              WP.push(() => {
                window.dataLayer.push({
                  event: "site_interaction",
                  eventCategory: "send_form",
                  eventAction:
                    "ontouchstart" in document.documentElement
                      ? "tap"
                      : "click",
                  eventLabel: window.location.href,
                });
              });
              scrollToEvent(
                vC.getBoundingClientRect().top + window.scrollY - 90,
                () => {
                  project.isScrollingController(false);
                }
              );
            } catch (err) {
              console.log("Error:", err);
            }
          })();

          /* KONIEC FORMULARZA */
        }
      });
    });
  }
};
